import Logos from './Logos'
export default Logos
